import React, { useCallback, useEffect, useRef, useState } from 'react';

const ComposeText = ({ text, maxHeight = 80 }: { text: string; maxHeight?: number }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const textRef = useRef<HTMLDivElement>(null);
  const checkForOverflow = useCallback(() => {
    if (textRef.current) {
      const isTextOverflowing = textRef.current.scrollHeight > maxHeight;
      setIsOverflowing(isTextOverflowing);
    }
  }, [textRef.current]);

  useEffect(() => {
    checkForOverflow();
    window.addEventListener('resize', checkForOverflow);
    return () => window.removeEventListener('resize', checkForOverflow);
  }, [checkForOverflow]);
  return (
    <>
      <div
        ref={textRef}
        // className={isExpanded ? 'block' : 'line-clamp-3'}
        style={{
          maxHeight: isExpanded ? 'none' : `${maxHeight}px`,
          lineHeight: '1.2',
          whiteSpace: 'pre-wrap',
          overflow: 'hidden',
        }}
      >
        {text}
      </div>
      {isOverflowing && (
        <button
          className="mt-2 text-brand transition-colors hover:text-brand-dark"
          onClick={() => setIsExpanded(!isExpanded)}
        >
          {isExpanded ? 'Read Less' : 'Read More'}
        </button>
      )}
    </>
  );
};

export default ComposeText;
